import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async lookup(event) {
    const btn = event.currentTarget
    const addressInput = document.getElementById(btn.dataset.addressId)
    const latInput    = document.getElementById(btn.dataset.latId)
    const lngInput    = document.getElementById(btn.dataset.lngId)

    const address = addressInput?.value?.trim()
    if (!address) {
      alert("Inserire prima l'indirizzo di ritrovo")
      return
    }

    const originalHtml = btn.innerHTML
    btn.disabled = true
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'

    try {
      const params = new URLSearchParams({ format: "json", q: address, limit: 1 })
      const response = await fetch(`https://nominatim.openstreetmap.org/search?${params}`, {
        headers: { "Accept-Language": "it,en" }
      })
      const results = await response.json()

      if (results.length > 0) {
        latInput.value = parseFloat(results[0].lat).toFixed(6)
        lngInput.value = parseFloat(results[0].lon).toFixed(6)
      } else {
        alert("Indirizzo non trovato. Prova ad aggiungere comune o provincia.")
      }
    } catch {
      alert("Errore di connessione. Riprova tra poco.")
    } finally {
      btn.disabled = false
      btn.innerHTML = originalHtml
    }
  }
}
